export const googleMapsApiKey = "AIzaSyAA2qhumHnkZVUH-Si3zU37-4fDQwPbo9A";
export const googleMapsID = "74e9fb4770924cb1";
export const GOOGLE_MAPS_LIBRARIES = Object.freeze(["places", "geometry"]);
export const S3_BUCKET = "guia-boomerang";
export const REGION = "us-east-2";
export const ACCESS_KEY = "AKIA4TI3V6ZL5ZIUX7ZH";
export const SECRET_ACCESS_KEY = "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";
export const HUBSPOT_KEY = "pat-na1-b9078a5d-87f2-40e8-bf85-2e6df3892873";
export const getApiBaseUrl = () => {
    const environment = process.env.NEXT_PUBLIC_ENV;
    return environment === "production"
        ? "https://api.grupoguia.mx"
        : "https://apidev.grupoguia.mx";
};
export const getSiteBaseUrl = () => {
    const environment = process.env.NEXT_PUBLIC_ENV;
    switch (environment) {
        case "production":
            return "https://grupoguia.mx";
        case "develop":
            return "https://develop.grupoguia.mx";
        default:
            return "http://localhost:3000";
    }
};
